// assets/perfume-widget.js
class PerfumeWidget extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    const style = document.createElement("style");
    style.textContent = `
      :host { display: block; }
      #widget-container { position: fixed; z-index: 9; /* z-index base del contenedor */ }
      #widget-iframe {
        border: none;
        width: 0; /* Inicialmente invisible */
        height: 0; /* Inicialmente invisible */
        opacity: 0; /* Inicialmente invisible */
        visibility: hidden; /* Inicialmente invisible */
        position: fixed;
        right: 20px;
        bottom: 90px;
        z-index: 1000; /* z-index inicial del iframe (botón flotante) */
        border-radius: 5rem;
        transition: all 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0s linear 0.3s;
        background-color: transparent; /* Por defecto transparente */
      }
    `;

    const container = document.createElement("div");
    container.id = "widget-container";

    const iframe = document.createElement("iframe");
    iframe.id = "widget-iframe";

    const shopifyOrigin = window.location.origin;

    const getLangFromPath = () => {
      // NOTE: The list of supported languages is based on the available `src/messages/*.json` files.
      const supportedLangs = ["de", "en", "es", "fr", "it", "nl", "pt"];
      const pathParts = window.location.pathname.split("/").filter(Boolean);

      if (pathParts.length > 0) {
        // Assumes language is the first part of the path, e.g. /es-es/
        const potentialLang = pathParts[0].toLowerCase().split("-")[0];
        if (supportedLangs.includes(potentialLang)) {
          return potentialLang;
        }
      }
      return null;
    };

    // Detect language from URL path, fallback to query param, then to 'es'.
    const lang =
      getLangFromPath() ||
      new URLSearchParams(window.location.search).get("lang") ||
      "en";

    iframe.src = `https://fragrancecode.com/perfume-widget/dist/?lang=${lang}&shopOrigin=${encodeURIComponent(
      shopifyOrigin
    )}`;

    this.shadowRoot.appendChild(style);
    container.appendChild(iframe);
    this.shadowRoot.appendChild(container);

    this.iframe = iframe;
    this.setupEventListeners();

    // ... resto del código de perfume-widget.js (applyStyles, setupEventListeners, etc.) ...
    // Listener para evento global (si otra parte de tu tema lo dispara)
    document.addEventListener("openPerfumeWidget", () => {
      console.log(
        "Perfume-widget.js: Event 'openPerfumeWidget' received on document."
      );
      this.applyStyles("openWidget"); // Usar el método unificado
    });

    // Exponer controlador global
    window.PerfumeWidgetController = {
      open: () => {
        const widget = document.querySelector("perfume-widget");
        if (widget) {
          console.log(
            "Perfume-widget.js: PerfumeWidgetController.open() called."
          );
          widget.applyStyles("openWidget"); // Usar el método unificado

          // Notificar al iframe para que cambie su contenido a "abierto"
          if (widget.iframe && widget.iframe.contentWindow) {
            let targetOrigin = "*";
            if (widget.iframe.src) {
              try {
                targetOrigin = new URL(widget.iframe.src).origin;
              } catch (e) {
                console.error(
                  "Perfume-widget.js: Error parsing iframe src for targetOrigin",
                  e
                );
                // targetOrigin remains "*" as a fallback
              }
            }
            widget.iframe.contentWindow.postMessage(
              { action: "controllerOpenWidget" },
              targetOrigin
            );
            console.log(
              "Perfume-widget.js: Sent 'controllerOpenWidget' message to iframe with targetOrigin:",
              targetOrigin
            );
          }
        } else {
          console.warn(
            "Perfume-widget.js: PerfumeWidgetController.open() - widget not found."
          );
        }
      },
    };
  }

  applyStyles(action) {
    const isMobile = window.innerWidth <= 768;
    console.log(
      `Perfume-widget.js: applyStyles called with action: ${action}, isMobile: ${isMobile}`
    );

    const zIndexOpen = "9999";
    const zIndexClosed = "1000";

    if (action === "openWidget") {
      this.iframe.style.opacity = "1";
      this.iframe.style.visibility = "visible";
      this.iframe.style.transition =
        "all 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0s linear 0s";
      this.iframe.style.zIndex = zIndexOpen;
      this.iframe.style.backgroundColor = ""; // Restablecer al valor por defecto del CSS interno del widget o del navegador
      this.iframe.style.boxShadow = isMobile
        ? "0 -4px 12px rgba(0,0,0,0.1)"
        : "0 8px 25px rgba(0,0,0,0.2)";

      if (isMobile) {
        this.iframe.style.position = "fixed";
        this.iframe.style.right = "0";
        this.iframe.style.bottom = "0";
        this.iframe.style.width = "100vw";
        this.iframe.style.height = "90vh";
        this.iframe.style.left = "0";
        this.iframe.style.top = "auto";
        this.iframe.style.borderRadius = "10px 10px 0 0";
        this.iframe.style.maxHeight = "700px";
        this.iframe.style.right = "20px";
        this.iframe.style.bottom = "20px";
        this.iframe.style.borderRadius = "12px";
        this.iframe.style.border = "1px solid #e0e0e0";
        document.body.style.overflow = "hidden";
      } else {
        this.iframe.style.position = "fixed";
        this.iframe.style.left = "auto";
        this.iframe.style.top = "auto";
        this.iframe.style.width = "400px";
        this.iframe.style.height = "85vh";
        this.iframe.style.maxHeight = "700px";
        this.iframe.style.right = "20px";
        this.iframe.style.bottom = "20px";
        this.iframe.style.borderRadius = "12px";
        this.iframe.style.border = "1px solid #e0e0e0";
        this.iframe.style.boxShadow = "0 8px 25px rgba(0,0,0,0.2)";
        document.body.style.overflow = "";
      }
    } else if (action === "closeWidget") {
      this.iframe.style.opacity = "1"; // El iframe en sí es visible
      this.iframe.style.visibility = "visible"; // El iframe en sí es visible
      this.iframe.style.transition =
        "all 0.3s ease-in-out, opacity 0.3s ease-in-out, visibility 0s linear 0s";

      this.iframe.style.zIndex = zIndexClosed;
      this.iframe.style.left = "auto";
      this.iframe.style.top = "auto";
      this.iframe.style.width = "100px"; // Tamaño para el botón flotante
      this.iframe.style.height = "100px"; // Tamaño para el botón flotante
      this.iframe.style.right = "20px";
      this.iframe.style.bottom = "90px";
      this.iframe.style.borderRadius = "5rem";
      this.iframe.style.border = "none";
      this.iframe.style.boxShadow = "none"; // Sin sombra en el contenedor del iframe
      this.iframe.style.backgroundColor = "transparent"; // Fondo del iframe transparente
      document.body.style.overflow = "";
    }
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  setupEventListeners() {
    window.addEventListener("message", (event) => {
      const allowedOrigins = [
        "https://fragrancecode.com",
        "https://localhost:3002",
      ];

      if (!allowedOrigins.includes(event.origin)) {
        return;
      }

      const { action, data } = event.data;
      console.log(
        "Perfume-widget.js: Message received from iframe:",
        event.data
      );

      if (action === "openWidget" || action === "closeWidget") {
        this.applyStyles(action);
      } else if (action === "addToCart") {
        const productHandle = data.variantId; // Sigue siendo el handle
        const quantity = data.quantity || 1;
        const widgetOrigin = event.origin;

        if (productHandle) {
          console.log(
            `Perfume-widget.js: Received productHandle for cart: ${productHandle}`
          );
          const productJsonUrl = `https://${window.location.hostname}/products/${productHandle}.js`;
          console.log(
            `Perfume-widget.js: Fetching product JSON from: ${productJsonUrl}`
          );

          fetch(productJsonUrl)
            .then((response) => {
              if (!response.ok) {
                return response.text().then((text) => {
                  throw new Error(
                    `Product data not found for handle ${productHandle}. Status: ${response.status}. Response: ${text}`
                  );
                });
              }
              return response.json();
            })
            .then((productData) => {
              if (
                !productData ||
                !productData.variants ||
                productData.variants.length === 0
              ) {
                throw new Error(
                  `No variants found for product handle ${productHandle}. Data: ${JSON.stringify(
                    productData
                  )}`
                );
              }

              const firstVariant = productData.variants[0];
              const actualShopifyVariantId = firstVariant.id;
              const isAvailable = firstVariant.available;

              if (!actualShopifyVariantId) {
                throw new Error(
                  `Could not extract a valid Shopify Variant ID for handle ${productHandle}.`
                );
              }
              console.log(
                `Perfume-widget.js: Product handle ${productHandle}, Shopify Variant ID: ${actualShopifyVariantId}, Available: ${isAvailable}`
              );

              if (isAvailable) {
                const body = JSON.stringify({
                  items: [{ id: actualShopifyVariantId, quantity: quantity }],
                  sections: [
                    "cart-icon-bubble",
                    "cart-drawer",
                    "cart-notification-product",
                    "cart-notification-button",
                  ],
                  sections_url: window.location.pathname,
                });
                return fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: body,
                })
                  .then((addToCartResponse) => {
                    if (!addToCartResponse.ok) {
                      return addToCartResponse.json().then((errData) => {
                        throw new Error(
                          errData.message ||
                            errData.description ||
                            `Error adding to cart. Status: ${addToCartResponse.status}`
                        );
                      });
                    }
                    return addToCartResponse.json();
                  })
                  .then((cartData) => {
                    console.log(
                      "Respuesta de /cart/add.js (cartData):",
                      JSON.stringify(cartData, null, 2)
                    );

                    let itemCount = 0;
                    if (cartData && Array.isArray(cartData.items)) {
                      itemCount = cartData.items.reduce(
                        (total, item) => total + item.quantity,
                        0
                      );
                    } else {
                      console.warn(
                        "La respuesta de /cart/add.js no tiene un array 'items' o 'item_count' en el nivel raíz como se esperaba. El conteo de la burbuja puede ser incorrecto."
                      );
                    }

                    console.log(
                      `Derivado itemCount: ${itemCount} a partir de la suma de cantidades de items.`
                    );

                    const eventName = "cart:update";
                    console.log(
                      `PREPARING to dispatch '${eventName}' con itemCount: ${itemCount}`
                    );
                    document.dispatchEvent(
                      new CustomEvent(eventName, {
                        bubbles: true,
                        detail: {
                          resource: cartData,
                          sourceId: "perfume-widget",
                          source: "perfume-widget",
                          data: {
                            itemCount: itemCount,
                            source: "perfume-widget",
                          },
                        },
                      })
                    );
                    console.log(`FINISHED dispatching '${eventName}' event.`);

                    if (this.iframe && this.iframe.contentWindow) {
                      this.iframe.contentWindow.postMessage(
                        {
                          action: "itemAddedToCartFeedback",
                          data: {
                            productHandle: productHandle,
                            variantId: actualShopifyVariantId,
                            success: true,
                            itemCount: itemCount,
                          },
                        },
                        widgetOrigin
                      );
                    }

                    setTimeout(() => {
                      console.log(
                        "Perfume-widget.js: Setting _perfumeWidgetJustAddedToCart = false"
                      );
                      window._perfumeWidgetJustAddedToCart = false;
                    }, 500);

                    const cartNotificationElement =
                      document.querySelector("cart-notification");
                    if (
                      cartData.sections &&
                      cartData.sections["cart-icon-bubble"]
                    ) {
                      console.log(
                        "HTML para cart-icon-bubble desde Shopify:",
                        cartData.sections["cart-icon-bubble"]
                      );
                      const bubbleSectionHtml = new DOMParser()
                        .parseFromString(
                          cartData.sections["cart-icon-bubble"],
                          "text/html"
                        )
                        .querySelector(".shopify-section").innerHTML;
                      const bubbleElement =
                        document.getElementById("cart-icon-bubble");
                      if (bubbleElement) {
                        bubbleElement.innerHTML = bubbleSectionHtml;
                        console.log(
                          "Burbuja del carrito actualizada directamente por perfume-widget.js"
                        );
                      }
                    }
                  });
              } else {
                // Producto AGOTADO
                // ... (lógica de postMessage para producto agotado como antes)
                console.log(
                  `Perfume-widget.js: Product ${productHandle} is OUT OF STOCK.`
                );
                if (this.iframe && this.iframe.contentWindow) {
                  this.iframe.contentWindow.postMessage(
                    {
                      action: "productStockStatus",
                      data: {
                        productHandle: productHandle,
                        isAvailable: false,
                        variantId: actualShopifyVariantId,
                      },
                    },
                    widgetOrigin
                  );
                }
                return Promise.resolve({
                  skipped: true,
                  reason: "Out of stock",
                });
              }
            })
            .catch((error) => {
              // Catch para el fetch de productJsonUrl y /cart/add.js
              // ... (manejo de errores como antes)
              console.error(
                "Perfume-widget.js: Error in addToCart process:",
                error
              );
              let productNotFoundOrUnavailable = false;

              if (
                error.message &&
                (error.message.includes("Product data not found") ||
                  error.message.includes("No variants found") ||
                  error.message.includes("Status: 404"))
              ) {
                productNotFoundOrUnavailable = true;
                if (this.iframe && this.iframe.contentWindow) {
                  this.iframe.contentWindow.postMessage(
                    {
                      action: "productStockStatus",
                      data: {
                        productHandle: productHandle,
                        isAvailable: false,
                        productNotFound: true,
                      },
                    },
                    widgetOrigin
                  );
                }
              }

              if (
                this.iframe &&
                this.iframe.contentWindow &&
                !productNotFoundOrUnavailable &&
                (!error.message ||
                  !error.message.toLowerCase().includes("out of stock"))
              ) {
                this.iframe.contentWindow.postMessage(
                  {
                    action: "itemAddedToCartFeedback",
                    data: {
                      productHandle: productHandle,
                      success: false,
                      error: error.message,
                    },
                  },
                  widgetOrigin
                );
              }

              if (
                !productNotFoundOrUnavailable &&
                (!error.message ||
                  !error.message.toLowerCase().includes("out of stock"))
              ) {
                alert(`An error occurred: ${error.message}`);
              }
            });
        } else {
          // if (productHandle)
          // ... (manejo de productHandle faltante como antes)
          console.warn(
            "Perfume-widget.js: addToCart action received without productHandle (in data.variantId)."
          );
          alert("Cannot add to cart: Product identifier is missing.");
        }
      } // cierre de 'else if addToCart'
    }); // cierre de addEventListener 'message'

    const debouncedResize = this.debounce(() => {
      if (
        this.iframe.style.width !== "100px" ||
        this.iframe.style.height !== "100px"
      ) {
        console.log(
          "Perfume-widget.js: Resize detected, re-applying openWidget styles."
        );
        this.applyStyles("openWidget");
      }
    }, 250);

    window.addEventListener("resize", debouncedResize);

    window.addEventListener("orientationchange", () => {
      setTimeout(() => {
        if (
          this.iframe.style.width !== "100px" ||
          this.iframe.style.height !== "100px"
        ) {
          console.log(
            "Perfume-widget.js: Orientation change detected, re-applying openWidget styles."
          );
          this.applyStyles("openWidget");
        }
      }, 150);
    });
  }
}

if (customElements.get("perfume-widget")) {
  console.log("Perfume-widget.js: 'perfume-widget' already defined.");
} else {
  customElements.define("perfume-widget", PerfumeWidget);
  console.log("Perfume-widget.js: 'perfume-widget' defined.");
}
